// Read Aloud's gate: the only Read Aloud code in the main bundle. The reader and its player are a
// lazy chunk (app/read-aloud.js), loaded the first time someone presses play. Everything it needs
// from the app is handed over here, so the chunk has no copy of the app's state.
import { get, set, subscribe } from "../shared/settings-store.js";
import { active } from "./state.js";
import { activePage, frameWin, remoteOf } from "./ext-frames.js";
import { announce } from "./announce.js";
import { emitIsland, islandOn } from "./island-gate.js";
import { openSettings } from "./tabs.js";

let api = null, loading = null;
const subs = new Set();
const changed = () => { for (const f of subs) { try { f(); } catch { /* one listener */ } } };

function load() {
	if (!loading) {
		loading = import(__RVM.readJs).then((m) => {
			api = m.start({ get, set, subscribe, active, activePage, frameWin, remoteOf, announce, openSettings, changed, island: (d) => emitIsland("read", d), islandOn });
			return api;
		}).catch(() => { loading = null; announce("Read Aloud couldn't load. Check your connection and try again."); return null; });
	}
	return loading;
}

export const readGate = {
	reading: () => !!(api && api.reading()),
	// The toolbar button and Alt+R: open the player and start, or pause and resume.
	toggle(anchor) { load().then((a) => a && a.toggle(anchor || null)); },
	onChange(fn) { subs.add(fn); },
};

// Alt+R anywhere, while Read Aloud is on.
export const isReadKey = (e) => e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.code === "KeyR" && get("extReadAloud") === true;
